import React, {useEffect, useState} from "react";
import {changeStringCase, checkNullArr, checkNullJson, checkNullStr, getDefStr, isBoolTrue, printError, printLog, randomStr} from "../utils/ReactUtils";
import PropTypes from 'prop-types';
import {DefStrNA} from "../config/FusionConfig";

/**
 * Create labeled card that multiple labels and their data.
 *
 *  Data format:
 *
 * <pre>
 *     [
 *         { name:'Name', data:'Data'},
 *         { name:'Name', data:'Data'},
 *         { name:'Name', data:'Data'},
 *      ]
 * </pre>
 */
const LabelCard = React.memo(({
                                  className = "",
                                  wrapperClassName = "",
                                  key,
                                  fsVariant = 'md',
                                  style = {},
                                  wrapperStyle = {},
                                  height = "auto",
                                  children,
                                  nameWidth = "25%",
                                  nameClassName = "",
                                  dataClassName = "",
                                  dataLink = "",

                                  onControl,
                                  showControl = true,
                                  wrapBgData = true,
                                  autoNameWidth = false,
                                  capitalizeName = false,
                                  nameReplaceables = [],
                                  nameReplacement = "",
                                  dataReplaceables = [],
                                  dataReplacement = "",
                                  ...rest
                              }) => {
    const TAG = 'LabelCard';
    const LABEL_NAME_CLS = `${TAG + randomStr(5)}name_field`

    const [cardData, setCardData] = useState({});

    const [nameLabelW, setNameLabelW] = useState();

    useEffect(() => {
        setCardData(children);
        calcNameFieldWidth();
    }, [children]);

    useEffect(() => {
        calcNameFieldWidth();
    }, [cardData]);

    const NAME_W = "100px";
    const FONT_SIZE = "13px";

    const calcNameFieldWidth = () => {
        try {
            //set max width to all name-fields
            // const nameItems = document.getElementsByClassName(LABEL_NAME_CLS);
            // const nameElements = Array.from(nameItems);
            const nameElements = document.querySelectorAll('.' + LABEL_NAME_CLS);
            // log("nameElements:", nameElements, 'length', getArrLen(nameElements));
            let maxWidth = 0;
            nameElements.forEach((span) => {
                const spanWidth = parseInt(span.offsetWidth);
                // log("spanWidth:", spanWidth);
                if (spanWidth > maxWidth) {
                    maxWidth = spanWidth;
                }
            });
            // log("maxWidth:", maxWidth);
            if (maxWidth > 0) {
                // maxWidth = isBoolTrue(autoNameWidth) ? maxWidth + 'px' : nameWidth;
                maxWidth = maxWidth + 'px';
                nameElements.forEach((span) => {
                    span.style.width = maxWidth;
                    span.style.minWidth = maxWidth;
                    span.style.maxWidth = maxWidth;
                });
            }
        } catch (e) {
            logErr(e);
        }
    }
    return (<div className={`label-card-wrapper m-0 p-0 transition ${wrapperClassName}`} style={{...wrapperStyle}}
                 key={wrapperClassName + className + height + +key}>
        <div
            className={`section label-card ${className} m-0 p-0 ${!checkNullJson(cardData) ? 'bg-gray-light' : 'bg-white'}`}
            style={{height: !checkNullJson(cardData) ? '100px' : height, ...style}}
            {...rest}>
            {checkNullJson(cardData) && <div className="inner-wrapper p-0 m-0 w-100 transition px-1 py-1 overflow-hidden">
                {checkNullStr(cardData['title']) && <h6 className={`card-title fs-${fsVariant} mb-0 py-1 px-2`}>{cardData['title']}</h6>}
                {checkNullArr(cardData['items']) && cardData['items'].map((item, i) => {
                    const currKey = getCurrKey(item);
                    const name = getName(currKey);
                    // const data = getDefValue(item[currKey], DefStr);
                    const data = item[currKey];
                    const isDataBig = (data + "").length > 40;

                    return <div
                        className={`data-wrapper d-flex flex-${(isDataBig && wrapBgData) ? 'wrap' : 'nowrap'} fd-row m-0 px-2`}
                        style={{padding: ".15rem"}} key={name + key + i}>
                        <label
                            className={`${LABEL_NAME_CLS} fs-${fsVariant} fw-semi-bold overflow-hidden text-nowrap m-0 p-0 px-1 pe-1 ${nameClassName}`}> {name}
                        </label>
                        <p className={`overflow-hidden text-wrap flex-wrap m-0 p-0 px-1 text-justifyx text-break-space ${dataClassName} fs-${fsVariant}`}>{getDefStr(getStrData(data), DefStrNA)}</p>
                    </div>
                })}
            </div>}
        </div>
    </div>);

    function getCurrKey(item) {
        return Object.keys(item) + "";
    }

    function getName(name) {
        let str = (name + "").trim();
        str = str.replaceAll('_', ' ');
        if (checkNullArr(nameReplaceables)) {
            for (let item of nameReplaceables) {
                str = str.replaceAll(item, nameReplacement + "");
            }
        }
        if (isBoolTrue(capitalizeName)) str = changeStringCase(str, 'capitalize')
        return str;
    }

    function getStrData(data) {
        let str = (data + "").trim();
        // printLog(TAG, "getStrData.dataReplaceables:", dataReplaceables);
        if (checkNullArr(dataReplaceables)) {
            for (let item of dataReplaceables) {
                // printLog(TAG, "getStrData.dataReplaceables-for.item:", item);
                str = str.replaceAll(item, dataReplacement + "");
            }
        }
        return (str + "").trim();
    }

    function log(...text) {
        printLog(TAG, ...text);
    }

    function logErr(...text) {
        printError(TAG, ...text);
    }
});
LabelCard.propTypes = {
    className: PropTypes.string,
    wrapperClassName: PropTypes.string,
    key: PropTypes.string,
    style: PropTypes.object,
    wrapperStyle: PropTypes.object,
    height: PropTypes.string,
    children: PropTypes.any,
    onControl: PropTypes.func,
    autoNameWidth: PropTypes.bool,
    showControl: PropTypes.bool,
    wrapBgData: PropTypes.bool,
    capitalizeName: PropTypes.bool,
    nameWidth: PropTypes.string,
    fsVariant: PropTypes.string,
    nameClassName: PropTypes.string,
    dataClassName: PropTypes.string,
    dataLink: PropTypes.string,
    nameReplaceables: PropTypes.array,
    nameReplacement: PropTypes.string,
    dataReplaceables: PropTypes.array,
    dataReplacement: PropTypes.string,
};

export default LabelCard;
